import { apiClient } from './api-client';

export interface TenantSettings {
  allowMultipleShareLinks: boolean;
}

export const settingsApi = {
  async get(): Promise<TenantSettings> {
    const { data } = await apiClient.get('/settings');
    return data;
  },

  async update(settings: Partial<TenantSettings>): Promise<TenantSettings> {
    const { data } = await apiClient.patch('/settings', settings);
    return data;
  },
};
